import { useIntl } from 'react-intl';
import { useMutation, useQueryClient } from '@tanstack/react-query';

import { API } from 'src/reactQuery/Api';
import { postRequest } from 'src/utils/request';
import { QUERY_KEYS } from 'src/reactQuery/QueryKeys';
import messages from 'src/pages/TutorialDetailsPage/messages';
import { RequestSimplifiedData } from 'src/types/requestData';
import { useMessageHandler } from 'src/utils/hooks/useMessageHandler';

export type QuestionOptionParamsType = {
  code: string;
  textEn: string;
  textDe: string;
  isVisible: boolean;
  isCorrect: boolean;
  questionUuid: string;
  tutorialUuid: string;
};

const createQuestionOption = async (
  questionOption: QuestionOptionParamsType,
) => {
  const { data } = await postRequest<RequestSimplifiedData>(
    API.POST.questionOption(questionOption.questionUuid),
    buildSaveTutorialOptionParams(questionOption),
  );

  return data;
};

export const useCreateQuestionOption = () => {
  const client = useQueryClient();
  const { formatMessage } = useIntl();
  const { handleError, handleSuccess } = useMessageHandler();

  return useMutation({
    mutationFn: createQuestionOption,
    onSuccess: () => {
      handleSuccess(formatMessage(messages.tutorialOptionSaved), 1000);
      client.invalidateQueries({ queryKey: [QUERY_KEYS.TUTORIAL_QUESTIONS] });
    },
    onError: handleError,
  });
};

export function buildSaveTutorialOptionParams(
  questionOption: QuestionOptionParamsType,
) {
  return {
    tutorial_option: {
      code: questionOption.code,
      text_en: questionOption.textEn,
      text_de: questionOption.textDe,
      is_visible: questionOption.isVisible,
      is_correct: questionOption.isCorrect,
      tutorial_uuid: questionOption.tutorialUuid,
    },
  };
}
